import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const styles = StyleSheet.create({
    item: {
        flex: 1,
        width: Dimensions.get('window').width,
        height: 150,
        backgroundColor: 'blue',
        justifyContent: 'center',
        alignItems: 'center',
    },
    button: {
        color: 'white',
    },
    img1: {
        width: Dimensions.get('window').width,
        // Dejar que la imagen calcule su alto por proporción
    },
    img2: {
        width: Dimensions.get('window').width,
        // Quitar alto fijo y aspectRatio forzado para no achicar el preview
    },
    containerText: {
        flex: 1,
        justifyContent: 'center',
        top: 82,
    },
    text: {
        width: '100%',
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.textSecondary,
        alignSelf: 'center',
        alignContent: 'center',
    },
})
export default styles
